module.exports = __webpack_public_path__ + "img/i_homework-status-checked.f0ea6e78.svg";